import { Box, Paper, Stack, Skeleton } from '@mui/material';

const GrossSales : React.FC<any> = ({ data }) => {

    return (
        <Box>
            <Paper sx={{ backgroundColor: '#64b5f6', color: '#fff', p:1 }}>
                { data.loading ?
               <Box>
                    <Skeleton height={70} variant="rectangular" />
               </Box>
               :
               <Box>
                { data.data.po_rtp ? 
                <Stack flexDirection="row" justifyContent="space-between" >
                        <Box fontSize={35} fontWeight={400}>{data.data.po_rtp.length ? data.data.po_rtp[0].count : 0}</Box>
                        <Box fontSize={13} sx={{ textAlign: 'right' }}>
                            <Box>PO's In RTP</Box>
                            <Box>Gross Sales</Box>
                            <Box fontSize={14}>Rp. {data.data.po_rtp.length ? data.data.po_rtp[0].totalAmount.toLocaleString() : 0} </Box> 
                        </Box>
                </Stack> : null }
                {/* <Stack flexDirection="row" justifyContent="flex-end">
                        <Box fontSize={13} fontWeight={600} color="red">-7% from a week ago</Box>
                </Stack> */}
               </Box> }
            </Paper>
        </Box>
    )
}

export default GrossSales
